module.exports = __webpack_public_path__ + "static/img/az.f0e9656a.png";